export enum HexaBadgeColorType {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  NEUTRAL = 'neutral',
  IN_PROGRESS = 'in-progress',
}
